var map = {
	"./emoji/angry.png": 532,
	"./emoji/happy.png": 940,
	"./emoji/laughing.png": 755,
	"./emoji/sad.png": 829,
	"./emoji/wow.png": 465,
	"./heart.png": 528,
	"./logo1.png": 366,
	"./logo2.png": 603,
	"./start.jpeg": 851,
	"./user.png": 948,
	"./wave.png": 52,
	"./강아지.jpeg": 702,
	"./고양이.jpeg": 576,
	"./꽃.jpeg": 472,
	"./바다.jpeg": 101,
	"./산.jpeg": 310,
	"./여행.jpeg": 601
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 327;